import React from "react";
import General from "../components/Contact/general-enqiure"; 
import Banner from '../comman/Banner/Banner';


const Generalenquire = () => {
  return (
    <>
    <Banner 
     index={'react-generalqury'}
    />
    <General/>    
    </>

  )
};

export default Generalenquire;